import { Outlet, ScrollRestoration, useLocation } from "react-router";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { MobileNav } from "./components/MobileNav";

/**
 * Root layout — header, animated page content, footer, mobile bottom nav.
 *
 * Page transitions: the `key={location.pathname}` on the wrapper div causes
 * React to remount the Outlet on every route change, which triggers the
 * `animate-page-enter` CSS animation (300ms fade + slide up).
 *
 * Mobile bottom padding (pb-20) prevents content from being hidden behind the
 * fixed MobileNav bar. On desktop (md+) the padding is removed.
 */
export function Root() {
	const location = useLocation();

	return (
		<>
			<Header />
			<main className="flex-1 pb-20 md:pb-0">
				<div key={location.pathname} className="animate-page-enter">
					<Outlet />
				</div>
			</main>
			<Footer />
			<MobileNav />
			<ScrollRestoration />
		</>
	);
}
